import { Anchor, Stack, Text, UnstyledButton } from "@mantine/core";
import type { ReactNode } from "react";
import type { LoginPageFooterLink } from "../../LoginPage";
import type { LoginTr } from "../../useLoginTranslations";
import styles from "../../LoginPage.module.css";

export interface LoginFormFooterProps {
  footerAgreement?: ReactNode;
  footerSupportLink?: LoginPageFooterLink;
}

export function LoginFormFooter({ footerAgreement, footerSupportLink }: LoginFormFooterProps) {
  if (!footerAgreement && !footerSupportLink) {
    return null;
  }

  return (
    <Stack gap="xs" className={styles.footerStack}>
      {footerAgreement && (
        <Text size="xs" className={styles.footerAgreement}>
          {footerAgreement}
        </Text>
      )}
      {footerSupportLink && (
        <Text size="xs" ta="center" lh={1.5} c="dimmed">
          <Anchor href={footerSupportLink.href} target="_blank" rel="noopener noreferrer" size="xs">
            {footerSupportLink.label}
          </Anchor>
        </Text>
      )}
    </Stack>
  );
}

export interface SignInSignUpToggleProps {
  isSignUp: boolean;
  onToggle: () => void;
  tr: LoginTr;
}

export function SignInSignUpToggle({ isSignUp, onToggle, tr }: SignInSignUpToggleProps) {
  return (
    <Text className={styles.toggleRow}>
      {tr(
        isSignUp ? "login.form.hasAccountPrompt" : "login.form.noAccountPrompt",
        isSignUp ? "Already have an account?" : "New to Collective Discovery?",
      )}{" "}
      <UnstyledButton component="span" className={styles.linkButtonBold} onClick={onToggle}>
        {isSignUp ? tr("login.form.switchToSignIn", "Log in") : tr("login.form.switchToSignUp", "Create an account")}
      </UnstyledButton>
    </Text>
  );
}
